import { useState, useEffect } from 'react';
import { universalBtoa } from '@web/js';
const MAX_ATTEMPTS = 3;
/**
 * Creates an element for each URL and injects them to head
 * @param {array} URLs array of URLs
 * @returns {boolean} true if all assets have loaded
 */

const useLoadAssets = URLs => {
  const [loaded, setLoaded] = useState(false);

  const injectAsset = async url => {
    const id = universalBtoa(url);
    if (document.getElementById(id)) return null;
    const head = document.getElementsByTagName('HEAD')[0];
    const link = document.createElement('link');
    link.id = id;
    link.href = url;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    head.appendChild(link);
    return new Promise((resolve, reject) => {
      link.onload = () => resolve(url);

      link.onerror = error => {
        head.removeChild(link);
        reject(error);
      };
    });
  };

  const determinedExecution = async function (fn, attempt) {
    if (attempt === void 0) {
      attempt = MAX_ATTEMPTS;
    }

    if (attempt > 0) {
      const result = await fn(attempt).catch(e => e);

      if (result && result.type === 'error') {
        return await determinedExecution(fn, attempt - 1);
      }

      return result;
    }

    throw Error("MAX_ATTEMPTS " + MAX_ATTEMPTS);
  };

  useEffect(() => {
    let isSubscribed = true;
    const promises = URLs.map(url => determinedExecution(() => injectAsset(url)));
    Promise.all(promises).then(() => isSubscribed && setLoaded(true)).catch(() => isSubscribed && setLoaded(false));
    return () => isSubscribed = false;
  }, []);
  return loaded;
};

export default useLoadAssets;